import { Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { EntrepriseOption } from '../models/entrepriseOption.model';
import { BaseApiService } from './base.api.service';

@Injectable({ providedIn: 'root' })
export class EntrepriseOptionService extends BaseApiService {
  listEntrepriseOptions() {
    return injectQuery(() => ({
      queryKey: ['entrepriseOptions'],
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<EntrepriseOption[]>(
              `${this.baseUrl}/api/core/EntrepriseOptions`,
              {
                withCredentials: true,
              }
            )
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }
}
